import { render, staticRenderFns } from "./ServicoDetalhar.vue?vue&type=template&id=37d2ecd3"
import script from "./ServicoDetalhar.vue?vue&type=script&lang=js"
export * from "./ServicoDetalhar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports